import React from "react";

const BrunelloHeader = () => {
    return (
        <>
            <div className="header">
                <img src="/assets/bc-logo.png" alt="" />
            </div>
            <div className="subheader">
                <div className="status">Live</div>
                <div>Casa Cucinelli</div>
            </div>
        </>
    )
}

export default BrunelloHeader;